import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
	useHistory,
	useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../components/shared/Loader";
import { Container } from "reactstrap";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { use } from "react";
import { useDispatch } from "react-redux";
import { updateMeta } from "../../store/actions/metaAction";
import server from "../../api/server";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import axios from "axios";

const EditDesign = () => {
	const { designSlug } = useParams();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const [selectedFile, setSelectedFile] = useState(null);
	const history = useHistory();
	const {
		register,
		handleSubmit,
		setValue,
		getValues,
		formState: { errors },
	} = useForm({
		defaultValues: {
			fileUrl: "",
		},
	});

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: " تعديل التصميم",
				breadcrumb: "التصاميم",
				button: {
					show: false,
					text: false,
					link: false,
				},
			})
		);
		try {
			const pageData = await server(cookie).get(
				`/pages/designs/sections/${designSlug}`
			);
			const section = pageData?.data?.data?.section;

			setValue("fileUrl", section?.fileUrl);
			setSelectedFile(section?.file);
			setLoading(false);
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة لاحقا!");
			setLoading(false);
		}
	};

	useEffect(() => {
		onStart();
	}, []);

	const handleUpload = async e => {
		const file = e.target.files?.[0];
		if (!file) return;

		setLoading(true);

		setSelectedFile({ name: file.name, size: file.size, type: file.type });
		const formData = new FormData();
		formData.append("file", file);

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/upload`,
				formData,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				}
			);

			const uploadedPath = `${process.env.REACT_APP_MAIN_URL}${response?.data?.data?.file?.path}`;

			if (uploadedPath) {
				setValue("fileUrl", uploadedPath);
				toast.success("تم رفع الملف بنجاح");
			}
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة مره اخرى!");
		} finally {
			setLoading(false);
		}
	};
	const renderFilePreview = () => {
		if (selectedFile?.type?.includes("image")) {
			return (
				<img
					src={getValues("fileUrl")}
					alt="preview"
					className="imagePreview"
					style={{
						width: "100%",
						maxHeight: "300px",
						objectFit: "contain",
					}}
				/>
			);
		} else {
			return (
				<video
					controls
					src={getValues("fileUrl")}
					className="videoPreview"
					style={{
						width: "100%",
						maxHeight: "300px",
						objectFit: "contain",
					}}
				/>
			);
		}
	};
	const submitHandler = async data => {
		data.title = "design";
		data.file = selectedFile;
		try {
			await server(cookie).put(`/pages/designs/sections/${designSlug}`, {
				section: data,
			});
			toast.success("تم تعديل التصميم بنجاح");
			if (selectedFile?.type?.includes("image")) {
				history.push("/designs/images");
			} else {
				history.push("/designs/videos");
			}
		} catch (error) {
			console.log(error);
		}
	};
	return (
		<div>
			{loading && <Loader />}
			<Container>
				<div className="card p-3">
					<form onSubmit={handleSubmit(submitHandler)}>
						<div className="col-xs-12 col-md-6 mx-auto">
							<div className="card-body">
								<div className="form-item mb-3">
									<label htmlFor="picture">التصميم</label>
									<input
										type="file"
										id="picture"
										accept="image/*,video/*"
										{...register("file", {
											required: "برجاء تحميل التصميم",
											onChange: handleUpload,
										})}
									/>
									<div className="mt-3">{renderFilePreview()}</div>
									{errors?.file && (
										<p className="text-danger mt-2">{errors.file.message}</p>
									)}
								</div>
								<div className="form-item mt-4">
									<button className="btn btn-success btn-block">ارسال</button>
								</div>
							</div>
						</div>
					</form>
				</div>
			</Container>
		</div>
	);
};

export default EditDesign;
